export default "__VITE_ASSET__d24caba2__"